// extracted by mini-css-extract-plugin
export var label = "question-module--label--CwSC1";
export var marathonQuestion = "question-module--marathon-question--6VFwk";
export var postContent = "question-module--post-content--nOtll";
export var postMainTitle = "question-module--post-main-title--+z-Ga";
export var weeklyChallenge = "question-module--weekly-challenge--Y-JyX";